const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class MobileSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.url = this.getAttribute("url");
    this.closeButton = this.querySelector("[data-close]");
    this.results = this.closest("mobile-menu").querySelector("[data-results]");
    this.openButton = this.closest("body").querySelector(
      ".header__search-icon",
    );
  }

  connectedCallback() {
    console.log("MobileSearch connected");
    const handleSearch = (input) => {
      if (input.value == "") {
        this.results.innerHTML = "";
        return;
      }

      this.getSearchResults(input.value);
    };

    this.onTyping = debounce(handleSearch, 300);

    this.input.addEventListener("input", (e) => {
      if (!this.classList.contains("typing")) {
        this.classList.add("typing");
        document.body.classList.add("mobile-search-open");
      }
      this.onTyping(this.input);
    });

    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.classList.remove("typing");
      document.body.classList.remove("mobile-search-open");
      this.results.innerHTML = "";
      this.input.value = "";
    });

    this.openButton.addEventListener("click", (e) => {
      if (window.innerWidth > 768) return;
      e.preventDefault();

      if (!this.classList.contains("typing")) {
        this.classList.add("typing");
        document.body.classList.add("mobile-search-open");
      }

      setTimeout(() => {
        this.input.focus();
      }, 300);
    });

    window.addEventListener("resize", (event) => {
      if (window.innerWidth > 960) {
        if (document.body.classList.contains("mobile-search-open")) {
          document.dispatchEvent(
            new CustomEvent("header-search:open", {
              bubbles: true,
              detail: {
                input: this.input.value,
              },
            }),
          );
        }

        this.classList.remove("typing");
        document.body.classList.remove("mobile-search-open");
        this.results.innerHTML = "";
        this.input.value = "";
      }
    });

    document.addEventListener("mobile-search:open", (e) => {
      if (!this.classList.contains("typing")) {
        this.classList.add("typing");
        document.body.classList.add("mobile-search-open");
        this.input.value = e.detail.input;
        this.getSearchResults(e.detail.input);
      }
    });

    document.addEventListener("mobile-search:close", (e) => {
      this.classList.remove("typing");
      document.body.classList.remove("mobile-search-open");
      this.results.innerHTML = "";
      this.input.value = "";
    });

    document.addEventListener("click", (event) => {
      if (!this.contains(event.target)) {
        this.classList.remove("typing");
        document.body.classList.remove("mobile-search-open");
        this.results.innerHTML = "";
        this.input.value = "";
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.classList.remove("typing");
        document.body.classList.remove("mobile-search-open");
        this.results.innerHTML = "";
        this.input.value = "";
      }
    });

    //listen for menu:close event
    document.addEventListener("mobile-menu:closed", () => {
      this.classList.remove("typing");
      this.results.innerHTML = "";
      this.input.value = "";
    });
  }

  getSearchResults(q) {
    let requestResponse;

    fetch(`${this.url}?q=${q}&section_id=predictive-search`)
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }

        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        this.results.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

if (!customElements.get("mobile-search")) {
  customElements.define("mobile-search", MobileSearch);
}
